import React from 'react';
import { IProps as IBlockProps, ISlide } from './HeroBannerCarouselBlock.interface';
import { HeroBannerCarouselBlock } from './HeroBannerCarouselBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IHeroBannerCarouselBlockInputProps {
    heading?: string;
    items?: Array<{
        backButton?: any;
        label?: string;
        heading?: string;
        content?: string;
        image?: {
            alternateText?: string;
            defaultSrc?: string;
            sizesAttribute?: string[];
            srcSet?: string[];
            srcSetWebp?: string[];
            isBackground?: boolean;
            textContent?: string;
            isLazy?: boolean;
        };
        buttons?: Array<{
            link?: {
                text?: string;
                target?: string;
                href?: string;
                title?: string;
                ariaLabel?: string;
            };
            buttonText?: string | null;
            btnStyle?: string;
            eventName?: string | null;
            icon?: string | null;
            iconDirection?: string;
        }>;
    }>;

    [key: string]: any; // Allows passthrough of BlockWrapper props and other dynamic fields
}

const mapInputToProps = (input: IHeroBannerCarouselBlockInputProps): IBlockProps => {


    const { heading, items, ...rest } = input;

    return {
        title: heading,
        slides: items ? items?.map((item: NonNullable<IHeroBannerCarouselBlockInputProps['items']>[number]) => {
            const { backButton, label, heading, content, image, buttons } = item;
            return {
                backButton: backButton ? translation.mapAnchorProps(backButton) : undefined,
                title: heading,
                description: content,
                buttons: buttons?.map((button: any) => (
                    translation.mapAnchorProps(button)
                )) as ISlide['buttons'],
                label: label,
                backgroundGradent: 'gradient-1',
                backgroundImage: image ? translation.mapImageProps(image) : undefined,
            }
        }) : [],
        ...rest, // Spread any other props that are not specifically mapped
    }// Type assertion might be needed if not all props are explicitly mapped
};

const HeroBannerCarouselBlockTranslation: React.FC<IHeroBannerCarouselBlockInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={HeroBannerCarouselBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default HeroBannerCarouselBlockTranslation;
